
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export interface NursingHome {
  id?: number;  // Making id optional since it might be missing in the database response
  center_name: string;
  nh_slug: string;
  description?: string;
  short_description?: string; // Added short_description field
  street_address?: string;
  city_town?: string;
  county_name?: string;
  county_slug?: string; // This is optional in the interface but will be provided in NursingHomePage
  eircode?: string;
  phone_number?: string;
  main_image_url?: string;
  latitude?: number;
  longitude?: number;
  price_range?: string;
  facilities?: string[];
  services?: string[];
  person_in_charge?: string;
  manager_name?: string;
  year_established?: number;
  amenities?: string[];
  room_types?: string[];
  email?: string;
  official_website?: string;
  hiqa_profile_url?: string;
  category?: string;
  max_residents?: number;
  standardized_phone_number?: string;
  standardized_address?: string;
  claimed?: boolean;
  // Include any other fields you need from your database
}

export function useNursingHome(nhSlug: string | undefined) {
  return useQuery({
    queryKey: ['nursing_home', nhSlug],
    queryFn: async (): Promise<NursingHome> => {
      try {
        const { data, error } = await supabase
          .from('nursing_homes')
          .select('*')
          .eq('nh_slug', nhSlug)
          .single();
        
        if (error) {
          console.error('Supabase error:', error);
          toast.error(`Database error: ${error.message}`);
          throw error;
        }
        
        console.log(`Viewing nursing home: ${data?.center_name}`);
        
        return data as unknown as NursingHome;  // Using unknown to bypass type checking since we know the structure
      } catch (err) {
        console.error('Error fetching nursing home:', err);
        toast.error("Failed to load nursing home details. Please try again later.");
        throw err;
      }
    },
    enabled: !!nhSlug,
  });
}
